/**
 * Identity constants for the user-licenses plugin and its entity card.
 *
 * These are extension identity, not permissions, and they change for different
 * reasons than the permission does — a card rename and a permission rename are
 * unrelated events. They live beside the other Tessa extension ids (see
 * `./types`) rather than in the permissions file.
 */

/** Plugin id used by the user-licenses backend route and its permission. */
export const USER_LICENSES_PLUGIN_ID = 'ns-tessa-user-licenses';

/** Card name registered by the user-licenses frontend plugin. */
export const USER_LICENSES_CARD_NAME = 'user-licenses';

/**
 * Full extension id used to govern the user-licenses entity card from
 * `app.extensions` in the app-config files.
 */
export const USER_LICENSES_CARD_EXTENSION_ID = `entity-card:${USER_LICENSES_PLUGIN_ID}/${USER_LICENSES_CARD_NAME}`;

/**
 * Entity kind the card attaches to, in the two spellings Backstage uses: the
 * blueprint filter lowercases kinds, while `entity.kind` carries the canonical
 * capitalised form. Deriving both from one place keeps a tightened or relocated
 * filter from drifting out of step with the component guard.
 */
export const USER_LICENSES_ENTITY_KIND = 'User';

/** Lower-cased form, as an `EntityCardBlueprint` filter expects it. */
export const USER_LICENSES_ENTITY_KIND_FILTER =
  USER_LICENSES_ENTITY_KIND.toLowerCase();
